import React from 'react';
import { Spinner } from 'flowbite-react';

const LoadingSpinner = () => (
  <div className="flex justify-center items-center mt-4">
    <Spinner size="lg" color="teal" aria-label="Loading..." />
  </div>
);

export default LoadingSpinner;
